import Button from '#components/a/Button'
import IconButton from '#components/a/IconButton'
import Text from '#components/a/Text'
import i18n from 'i18next'
import PropTypes from 'prop-types'
import React from 'react'
import ControlsGroup from './ControlsGroup'
import Tooltip from './Tooltip'
import Loading from '#components/a/Loading'

const COMMENT_MIN_LENGTH = 1
const COMMENT_MAX_LENGTH = 280

const ThumbsUpUnicode = '\u{1F44D}'
const HeartUnicode = '\u{1F49B}'
const EmojiUnicode = '\u{1F600}'

export default class CommentInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      commentText: '',
      rejectIsLoading: false,
      confirmIsLoading: false,
    }
    this.button = React.createRef()
    this.textarea = React.createRef()
  }

  handleReject = () => {
    const {rejectCallback} = this.props
    const {commentText} = this.state

    this.setState({rejectIsLoading: true})
    rejectCallback(commentText)
  }

  handleConfirm = () => {
    const {confirmCallback} = this.props
    const {commentText} = this.state

    this.setState({confirmIsLoading: true})
    confirmCallback(commentText ?? undefined)
  }

  componentDidMount() {
    if (this.props.commentText) {
      this.setState({commentText: this.props.commentText})
    }
  }

  handleCommentInputChange = text => {
    if (text.length <= COMMENT_MAX_LENGTH) {
      this.setState({
        commentText: text,
      })
    }
  }

  handleCommentInputChangeFromEvent = event => {
    this.handleCommentInputChange(event.target.value)
  }

  insertText = textToInsert => {
    const currentTextarea = this.textarea.current
    const {commentText} = this.state
    const {selectionEnd} = currentTextarea
    const result = commentText.substring(0, selectionEnd) + textToInsert + commentText.substring(selectionEnd)
    this.handleCommentInputChange(result)
  }

  render() {
    const {commentText, rejectIsLoading, confirmIsLoading} = this.state
    const {confirmCallback, rejectCallback} = this.props

    const titleText = i18n.t('nachweis_input_title_text')
    const placeholder = i18n.t('nachweis_input_placeholder_text')
    const confirmText = i18n.t('nachweis_freigeben_button')
    const rejectText = i18n.t('nachweis_ablehnen_button')

    return (
      <div className="commentInput">
        <Text text={titleText} />
        <div className="text-container">
          <textarea
            ref={this.textarea}
            className="commentInput__textbox"
            value={commentText}
            onChange={elem => this.handleCommentInputChangeFromEvent(elem)}
            placeholder={placeholder}></textarea>

          <div className="commentInput__emoji-btn">
            <div className="emoji-trigger">
              <Tooltip
                trigger={<IconButton icon="stylizedEmoji" />}
                triggerAction="click"
                modifier="dark small"
                placement="top">
                <div className="emoji-modal">
                  <IconButton event={() => this.insertText(EmojiUnicode)} icon="emoji" ref={this.button} />
                  <IconButton event={() => this.insertText(ThumbsUpUnicode)} icon="thumbsUp" ref={this.button} />
                  <IconButton event={() => this.insertText(HeartUnicode)} icon="heart" ref={this.button} />
                </div>
              </Tooltip>
            </div>
          </div>
          <ControlsGroup>
            <div style={{display: 'flex', justifyContent: 'center', width: '130px'}}>
              {rejectIsLoading ? (
                <Loading />
              ) : (
                <Button
                  testid="reject-button"
                  variant="secondary"
                  text={rejectText}
                  event={this.handleReject}
                  disabled={commentText.length < COMMENT_MIN_LENGTH}
                />
              )}{' '}
            </div>{' '}
            <div style={{display: 'flex', justifyContent: 'center', width: '130px'}}>
              {confirmIsLoading ? (
                <Loading />
              ) : (
                <Button testid="accept-button" variant="primary" text={confirmText} event={this.handleConfirm} />
              )}{' '}
            </div>
          </ControlsGroup>
        </div>
      </div>
    )
  }
}

CommentInput.propTypes = {
  id: PropTypes.string,
  commentText: PropTypes.string,
  confirmCallback: PropTypes.func.isRequired,
  rejectCallback: PropTypes.func.isRequired,
}
